//@flow

/*
  Take a path
  (i.e.: contact.id/ticket)

  and an object of ids
  (i.e.:
    {
      contacid: 95,
    }
  )

  to populate the path.
  (i.e.: contact.95/ticket )


*/

function populatePath(path: string, ids: { [string]: number }) {
  const explodedPath = path.split("/");

  const newPath = explodedPath.map(element => {
    const explodedElement = element.split(".");
    let newElement = [];
    if (explodedElement.length > 1) {
      newElement.push(explodedElement[0]);
      if (explodedElement[0] in ids) {
        newElement.push(ids[explodedElement[0]]);
      }

      return newElement.join(".");
    }
    return element;
  });

  return newPath.join("/");
}

export default populatePath;
